<div class="error-message">
    <img src="../../../../assets/resources/empty-state-error.svg" alt="">
    <h5> {{ title || '¡Oops!' }} </h5>
    <div [innerHtml]="subTitle || 'Algo ha ido mal, pero tiene solución'"></div>
    <app-button *ngIf="!hideButton" 
        icon="icon-refresh left" 
        (buttonClicked)="reload()">
        Recargar
    </app-button>
</div>